/** The employer-owned fields an employee may ask about. The keys are the server's allow-list (Identity `/api/me/employee-questions`). */
export const QUESTION_FIELDS = {
  employeeNumber: 'Employment ID',
  role: 'Role',
  jobTitle: 'Job Title',
  approvingOfficer: 'Approving Officer',
  wcClassCode: 'WC Class Code',
  hireDate: 'Hiring Date',
  ssn: 'SSN',
  paySchedule: 'Pay Schedule',
  payPeriodStartDate: 'Pay Period Start Date',
  payDay: 'Pay Day',
  department: 'Department',
  discipline: 'Discipline / Code',
  workArrangement: 'Work Arrangement',
  workType: 'Work Type',
  workLocation: 'Work Location',
  payType: 'Pay Type',
  rate: 'Rate',
} as const;

export type QuestionFieldKey = keyof typeof QUESTION_FIELDS;

export const QUESTION_MAX_LENGTH = 1000;

export const questionFieldLabel = (key: string): string => (QUESTION_FIELDS as Record<string, string>)[key] ?? key;

/** An employee's own question and the administrator's reply (if any). The response carries no email or name. */
export interface EmployeeQuestion {
  id: string;
  employeeId: string;
  fieldKey: string;
  message: string;
  createdAtUtc: string;
  status: 'open' | 'answered';
  reply: string | null;
  repliedAtUtc: string | null;
}
